import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams, Link} from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";

export default function CardViewStats() {
  const authState = useSelector((state) => state.authReducer);
  const userId = authState?.user?._id;

  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "mycardviews";

  const [list, setList] = useState([]);

  // ------------------ Dummy Fallback Data ------------------
  const dummyData = {
    mycardviews: [
      { viewerName: "Amit Sharma", viewerCode: "TU1234567890ABCD", clientName: "Bhavna Patel", clientCode: "TU99887766554433", viewDate: new Date() },
      { viewerName: "Chirag Jain", viewerCode: "TU55667788990011", clientName: "Divya Sethi", clientCode: "TU11112222333344", viewDate: new Date() },
    ],
    iviewed: [
      { viewerName: "Farhan Zaidi", viewerCode: "TU44556677889900", clientName: "Gauri Iyer", clientCode: "TUABCDEF12345678", viewDate: new Date() },
      { viewerName: "Harsh Mehta", viewerCode: "TUFF112233445566", clientName: "Jyoti Nair", clientCode: "TUGG778899001122", viewDate: new Date() },
    ],
  };

  // ------------------ Load Card Views ------------------
  const loadCardViews = useCallback(() => {
    if (!authState?.token || !userId) {
      setList(dummyData[activeTab] || []);
      return;
    }

    const config = {
      url: "/cardview/list",
      method: "post",
      headers: { Authorization: authState.token },
      data: { userId, mode: activeTab },
    };

    axios(config)
      .then((res) => {
        const data = res.data?.data;
        setList(data && data.length > 0 ? data : dummyData[activeTab]);
      })
      .catch(() => setList(dummyData[activeTab]));
  }, [activeTab, authState?.token, userId]);

  useEffect(() => {
    loadCardViews();
  }, [loadCardViews]);

  // ------------------ Tab Change ------------------
  const handleTabChange = (tabName) => {
    setSearchParams({ tab: tabName });
  };

  return (
    <div className="bg-black">
      <div className="min-h-[95vh] p-4 text-white">
        <header className="p-4 border-b border-blue-600 text-lg lg:text-xl font-bold bg-black text-yellow-200 mb-2">
          Think5Whys Contact Genious: Card View Stats
        </header>

        <div className="bg-black flex gap-4 mb-4">
          <button
            className={`px-4 py-2 rounded ${
              activeTab === "mycardviews" ? "bg-blue-600" : "bg-gray-700"
            }`}
            onClick={() => handleTabChange("mycardviews")}
          >
            My Card Views
          </button>

          <button
            className={`px-4 py-2 rounded ${
              activeTab === "iviewed" ? "bg-blue-600" : "bg-gray-700"
            }`}
            onClick={() => handleTabChange("iviewed")}
          >
            I Viewed
          </button>
        </div>

        {/* List */}
        <div className="space-y-2">
          {list.length === 0 ? (
            <div className="text-gray-400">No records found.</div>
          ) : (
            list.map((item, i) => (
              <div key={i} className="bg-gray-800 p-3 rounded">
                <div className="text-yellow-300 font-bold">
                  Viewer: {item.viewerName || "-"}
                </div>
                <div className="text-gray-300">
                  Viewer Code: {item.viewerCode || "-"}
                </div>
                <div className="text-gray-300">
                  Client Name: {item.clientName || "-"}
                </div>
                <div className="text-gray-300">
                  Client Code: {item.clientCode || "-"}
                </div>
                <div className="text-gray-400 text-sm">
                  Viewed On: {item.viewDate ? new Date(item.viewDate).toLocaleString() : "-"}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
